export default __webpack_public_path__ + "static/media/Checked.6386834b.png";